import DataTable from "@/components/DataTable/DataTable.vue";
import DataTableEmptyState from "@/components/DataTable/DataTableEmptyState.vue";
import RestTable from "@/components/RestTable/RestTable.vue";
import EmptyState from "@/components/Empty/EmptyState.vue";
import OverlayLoader from "@/components/Loader/Overlay.vue";
import UiSelect from "@/components/UiSelect/UiSelect.vue";
import UiTag from "@/components/UiTag/UiTag.vue";
import UiSpoiler from "@/components/UiSpoiler/UiSpoiler.vue";
import UiFormGroup from "@/components/UiFormGroup/UiFormGroup.vue";
import UiPage from "@/components/UiPage/UiPage.vue";
import UiDialogs from "@/components/UiDialogs/UiDialogs.vue";
import UiTagsInput from "@/components/UiTagsInput/UiTagsInput.vue";
import UiTimepicker from "@/components/UiTimepicker/UiTimepicker.vue";
import {
  UiDatePicker,
  UiMultiselect,
  UiInput,
  UiIcon,
  UiCheckbox,
  UiSkeleton,
  UiInputLabel,
  UiInputFeedback,
  UiDivider,
  UiSpinner,
  UiButton,
  UiFilePicker,
  UiFilePickerListItem,
  UiAlert,
  UiRadio,
  UiTabs,
  UiCard,
  UiCardSection,
  UiFormRadio,
  UiBadge,
  UiBreadcrumbs,
  UiPagination,
  UiModal,
  UiAvatar,
  UiTooltip,
  UiDataTable,
  UiDataTableTd,
  UiDataTableTr,
  UiStack,
  UiStackItem,
  UiPopover,
  UiOptionsMenu,
  UiOptionsMenuItem,
  UiOptionsMenuTitle,
  UiOptionsMenuDivider,
  UiSidebar,
  UiSidebarNavItem,
  UiSidebarNavHeader,
  UiToastProvider,
  UiFileInput,
} from "@bi-book/bibook-ui-kit";

export function declareGlobalComponents(app) {
  app.component("UiDialogs", UiDialogs);

  app.component("Stack", UiStack);
  app.component("StackItem", UiStackItem);

  app.component("DataTable", DataTable);
  app.component("DataTableEmptyState", DataTableEmptyState);
  app.component("RestTable", RestTable);

  app.component("EmptyState", EmptyState);
  app.component("OverlayLoader", OverlayLoader);
  // app.component("VueMonthlyPicker", VueMonthlyPicker);
  // app.component("v-select", vSelect);
  app.component("UiSelect", UiSelect);
  app.component("UiTag", UiTag);
  app.component("UiSpoiler", UiSpoiler);
  app.component("UiFormGroup", UiFormGroup);
  app.component("UiPage", UiPage);
  app.component("UiTagsInput", UiTagsInput);

  // UI Kit components
  app.component("UiSkeleton", UiSkeleton);
  app.component("UiButton", UiButton);
  app.component("UiStack", UiStack);
  app.component("UiStackItem", UiStackItem);
  app.component("UiTabs", UiTabs);
  app.component("UiMultiselect", UiMultiselect);
  app.component("UiPopover", UiPopover);
  app.component("UiOptionsMenu", UiOptionsMenu);
  app.component("UiOptionsMenuItem", UiOptionsMenuItem);
  app.component("UiOptionsMenuTitle", UiOptionsMenuTitle);
  app.component("UiOptionsMenuDivider", UiOptionsMenuDivider);
  app.component("UiAvatar", UiAvatar);
  app.component("UiIcon", UiIcon);
  app.component("UiCard", UiCard);
  app.component("UiCardSection", UiCardSection);
  app.component("UiSidebar", UiSidebar);
  app.component("UiSidebarNavHeader", UiSidebarNavHeader);
  app.component("UiSidebarNavItem", UiSidebarNavItem);
  app.component("UiInput", UiInput);
  app.component("UiInputLabel", UiInputLabel);
  app.component("UiInputFeedback", UiInputFeedback);
  app.component("UiDataTable", UiDataTable);
  app.component("UiDataTableTr", UiDataTableTr);
  app.component("UiDataTableTd", UiDataTableTd);
  app.component("UiPagination", UiPagination);
  app.component("UiBadge", UiBadge);
  app.component("UiDatePicker", UiDatePicker);
  app.component("UiCheckbox", UiCheckbox);
  app.component("UiTooltip", UiTooltip);
  app.component("UiSpinner", UiSpinner);
  app.component("UiDivider", UiDivider);
  app.component("UiAlert", UiAlert);
  app.component("UiRadio", UiRadio);
  app.component("UiModal", UiModal);
  app.component("UiFilePicker", UiFilePicker);
  app.component("UiFilePickerListItem", UiFilePickerListItem);
  app.component("UiToastProvider", UiToastProvider);
  app.component("UiTimepicker", UiTimepicker);
  app.component("UiFileInput", UiFileInput);
}
